import { IPublishTerm } from '../../../repositories/billing-tariffs/entities/PublishTerms/PublishTerm';
import { EServiceId } from '../../../types/reducers/publishTerms';
import { getServiceId } from '../../../utils/publishTerms';

export function getSelectedServiceId(terms: IPublishTerm[]): EServiceId | null {
  const defaultService = terms.find(({ isDefault }) => isDefault);

  return defaultService ? getServiceId(defaultService.services!) : null;
}
